module.exports = __webpack_public_path__ + "img/book_marketing_bg.42ef7925.jpg";